<script>

export default {
  name: 'ErrorComponent',
  props: ['error'],
  data () {
    return {
      defaultError () {
        return {
          statusCode: 500,
          message: '500'
        }
      }
    }
  },
  mounted () {
    this.$nuxt.error(this.error || this.defaultError)
    this.$raygun.send({
      error: this.error
    })
  }
}
</script>
